<!-- 能源概况 -->
<template>
    <div class='container'>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>总节能概况</span>
            </div>
            <div class="energy-box">
                <div class="left">
                    <div class="left-item">
                        <p class="energy-title">当月总节约电费</p>
                        <p class="energy-num">{{energy_conservation_data}} <span>元</span></p>
                    </div>
                    
                </div>
                <div class="charts-box">
                    <div class="totle-charts" id="chart1"></div>
                </div>
            </div>
        </el-card>
        <div style="height:20px;"></div>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>空调节能概况</span>
                    </div>
                    <div class="sys-energy-box">
                        <div class="energy-header">
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <p class="energy-title">当月总节约电费</p>
                                    <p class="energy-num">{{energy_air_data}} 元</p>
                                </el-col>
                                <el-col :span="12">
                                    <p class="energy-title">当月总电费</p>
                                    <p class="energy-num">{{energy_air_data_sum}} 元</p>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="charts-box">
                            <div class="sys-energy-charts" id="chart2"></div>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>水泵节能概况</span>
                    </div>
                    <div class="sys-energy-box">
                        <div class="energy-header">
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <p class="energy-title">当月总节约电费</p>
                                    <p class="energy-num">{{energy_pump_data}} 元</p>
                                </el-col>
                                <el-col :span="12">
                                    <p class="energy-title">当月总电费</p>
                                    <p class="energy-num">{{energy_pump_data_sum}} 元</p>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="charts-box">
                            <div class="sys-energy-charts" id="chart3"></div>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <div style="height:20px;"></div>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>空调电费概况</span>
                    </div>
                    <div class="sys-energy-box">
                       <ul class="situation-list">
                           <li class="situation-flex">
                               <span>本月节能电量：{{energy_air_data1}} kWh</span>
                           </li>
                           <li class="situation-flex">
                               <span>本月节能电费：{{energy_air_data}} 元</span>
                           </li>
                           <li class="situation-flex">
                               <span>本月节能率：{{energy_air_rate}} %</span>
                           </li>
                       </ul>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>水泵电费概况</span>
                    </div>
                    <div class="sys-energy-box">
                       <ul class="situation-list">
                           <li class="situation-flex">
                               <span>本月节能电量：{{energy_pump_data1}} kWh</span>
                           </li>
                           <li class="situation-flex">
                               <span>本月节能电费：{{energy_pump_data}} 元</span>
                           </li>
                           <li class="situation-flex">
                               
                           </li>
                       </ul>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import echarts from "echarts"
import Service from '@/api/Service'
import { FormatDate, FormatDateDay } from '@/utils/utils.js'

var chart1 = null, chart2 = null, chart3 = null;
export default {
    name:  'energysituation',
    data() {
        return {
            energy_conservation: [], // 总节约电费
            energy_conservation_data: 0, // 总节约电费

            energy_air: [],     //  空调节约电费列表
            energy_air_sum: [], //  空调总电费列表
            energy_air_data: 0,     //  空调节约电费
            energy_air_data_sum: 0, //  空调总电费
            energy_air_data1: 0,     //  空调节约电量
            energy_sum: 0, //  空调系统当月节能基数

            energy_pump: [],    //  水泵节约电费列表
            energy_pump_sum: [],    //  水泵总电费列表
            energy_pump_data: 0,    //  水泵节约电费
            energy_pump_data_sum: 0,    //  水泵总电费
            energy_pump_data1: 0,    //  水泵本月节能电量
            
        };
    },

    components: {},

    computed: {
        //  节约电量/基础电量
        //  水泵节能率
        energy_air_rate() {
            // let num = (this.energy_air_data1/this.energy_sum)
			let num = (this.energy_air_data/(this.energy_air_data_sum + this.energy_air_data))
            if(isNaN(num)) return 0
            let rate = (num*100).toFixed(2)

            return rate
        },
    },
    mounted() {
        // this.$nextTick(()=>{
            // 基于准备好的dom，初始化echarts实例
			let time = FormatDate('yyyy-MM-dd HH:mm:ss')
            chart1 = echarts.init(document.getElementById('chart1'));
            chart2 = echarts.init(document.getElementById('chart2'));
            chart3 = echarts.init(document.getElementById('chart3'));
			this.getEnergyConservation(time)
			this.getPumpConservation()
						
        // })
		
    },
	
    methods: {
        // 总+空调系统
        async getEnergyConservation(time) {
            let res = await Service.getEnergyConservation({time});
            if(res) {
                // 电费
                let fee_conservation = res.fee_conservation
                // 电量
                let energy_conservation = res.energy_conservation

            // 节能概况
                // 总节约   fee_conservation.sum_energy_conservation
                if(fee_conservation.sum_energy_conservation && fee_conservation.sum_energy_conservation.length>0) {
                    this.energy_conservation = fee_conservation.sum_energy_conservation.map(v=>{
                        return v.value
                    })
                    this.energy_conservation_data = this.energy_conservation[this.energy_conservation.length-1]
                }
            // 空调系统
                // 空调总节约电费  fee_conservation.energy_conservation
                if(fee_conservation.energy_conservation && fee_conservation.energy_conservation.length>0) {
                    this.energy_air = fee_conservation.energy_conservation.map(v=>{return v.value})
                    this.energy_air_data = this.energy_air[this.energy_air.length-1]
					// console.log(this.energy_air_data)
                }
                // 空调当前总电费   fee_conservation.electricity_statistic_list
                if(fee_conservation.electricity_statistic_list && fee_conservation.electricity_statistic_list.length>0) {
                    this.energy_air_sum = fee_conservation.electricity_statistic_list.map(v=>{return v.value})
                    this.energy_air_data_sum = this.energy_air_sum[this.energy_air_sum.length-1]
					// console.log(this.energy_air_data_sum)
                }
                // 空调节约电量 energy_conservation.energy_conservation
                if(energy_conservation.energy_conservation && energy_conservation.energy_conservation.length>0) {
                    let list1 = energy_conservation.energy_conservation.map(v=>{return v.value})
					
                    this.energy_air_data1 = list1[list1.length-1]
					// console.log(this.energy_air_data1)
                }
                // 空调当月节能基数
                if(energy_conservation.month_basic_energy && energy_conservation.month_basic_energy.length>0){
                    let month = new Date().getMonth()
                    this.energy_sum = energy_conservation.month_basic_energy[month].energy_sum
					// console.log(this.energy_sum)
                }
            }
            this.initData()
        },
        // 水泵节能
        async getPumpConservation() {
            let time_range = 'month'
            let time = FormatDate('yyyy-MM-dd HH:mm:ss')
            let res = await Service.getPumpStatisticByPIDTimeRange({ time_range, time });
            if(res) {
                
                let electricity_fee = res.electricity_fee
                let electricity = res.electricity
                // 水泵
                // 水泵当月总节约电费 electricity_fee.conservation_electricity_fee
                if(electricity_fee.conservation_electricity_fee && electricity_fee.conservation_electricity_fee.length>0) {
                    this.energy_pump = electricity_fee.conservation_electricity_fee.map(v=>{return v.value})
                    this.energy_pump_data = this.energy_pump[this.energy_pump.length-1]
                }
                // 水泵当月总电费  electricity_fee.sum_electricity_fee
                if(electricity_fee.sum_electricity_fee && electricity_fee.sum_electricity_fee.length>0) {
                    this.energy_pump_sum = electricity_fee.sum_electricity_fee.map(v=>{return v.value})
                    this.energy_pump_data_sum = this.energy_pump_sum[this.energy_pump_sum.length-1]
                }
                // 水泵本月节能电量 electricity.conservation_electricity
                if(electricity.conservation_electricity && electricity.conservation_electricity.length>0) {
                    let arr = electricity.conservation_electricity.map(v=>{return v.value})
                    this.energy_pump_data1 = arr[arr.length-1]
                }
                
            }
			// this.initData()
			this.initChart3(this.energy_pump, this.energy_pump_sum)
        },
        async initData() {
            this.initChart1(this.energy_conservation)
            this.initChart2(this.energy_air, this.energy_air_sum)
			// this.initChart3(this.energy_pump, this.energy_pump_sum)	
        },
        initChart1(otherDay) {
            let option = this.getOption();
            option.series =  [
                {
                    name: '总节约电费',
                    type: 'bar',
                    stack: '电费',
                    data: otherDay,
                    smooth: true,
                    itemStyle: {
                       color: 'rgba(56, 191, 96, 1)'
                    },
                },
            ]
            chart1.setOption(option);
        },
        initChart2(nowDay, otherDay) {
            let option = this.getOption();
            option.series =  [
                {
                    name: '总节约电费',
                    type: 'bar',
                    stack: '电费',
                    data: nowDay,
                    smooth: true,
                    itemStyle: {
                        color: 'rgba(56, 191, 96, 1)'
                        
                    },
                },
                {
                    name: '总电费',
                    type: 'bar',
                    smooth: true,
                    itemStyle: {
                        color: 'rgba(196, 178, 27, 1)'
                    },
                    data: otherDay,
                },
            ]
            chart2.setOption(option);
        },
        initChart3(nowDay, otherDay) {
            let option = this.getOption();
            option.series =  [
                {
                    name: '总节约电费',
                    type: 'bar',
                    stack: '电费',
                    data: nowDay,
                    smooth: true,
                    itemStyle: {
                        color: 'rgba(56, 191, 96, 1)'
                    },
                },
                {
                    name: '总电费',
                    type: 'bar',
                    smooth: true,
                    itemStyle: {
                        color: 'rgba(196, 178, 27, 1)'
                    },
                    data: otherDay,
                },
            ]
            chart3.setOption(option);
        },
        getOption() {
            return {
                tooltip: {
                    trigger: 'axis',
                    padding: [
                        5,  // 上
                        10, // 右
                        5,  // 下
                        10, // 左
                    ],
                    axisPointer: {
                        type: 'cross',
                    }
                },
                legend: {
                    data: ['总节约电费', '总电费'],
                    right: 160,
                    top: 10,
                },
                grid: {
                    left: 50,
                    right: 20,
                    bottom: 30,
                    top: 30,
                },
                
                xAxis: [
                    {
                        type: 'category',
                        data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
                    },
                ],

                yAxis: [
                    {
                        type: 'value',
                        name: '元',
                    }
                ],
                series: [
                    {
                        name: '总节约电费',
                        type: 'bar',
                        stack: '电费',
                        data: [],
                        smooth: true,
                        itemStyle: {
                            color: 'rgba(196, 178, 27, 1)'
                        },
                    },
                    {
                        name: '总电费',
                        type: 'bar',
                        smooth: true,
                        itemStyle: {
                            color: 'rgba(56, 191, 96, 1)'
                        },
                        data: [],
                    },
                ],
            }
        }
    }
}

</script>
<style lang='less' scoped>
    .energy-box{
        overflow: hidden;
        position: relative;
        height: 300px;
        .left{
            position: absolute;
            left: 0;
            width: 200px;
            top: 0;
            bottom: 0;
            z-index: 9;
            .left-item{
                margin-left: 30px;
                margin-top: 52px;
            }
        }
        .charts-box{
            position: absolute;
            left: 220px;
            right: 0;
            top: 0;
            height: 300px;
            // background-color: #ccc;
            .totle-charts{
                width: 100%;
                height: 100%;
            }
        }
    }

    .sys-energy-box{

        .energy-header{

        }
        .charts-box{
             width: 100%;
            height: 200px;
            // background-color: #ccc;
            .sys-energy-charts{
                width: 100%;
                height: 100%;
            }
        }
    }

    .situation-list{
        margin: 10px;
        .situation-flex{
            border-bottom: 1px solid #EBEEF5;
            display: flex;
            flex-direction: row;
            height: 40px;
            span{
                flex: 1;
                text-align: left;
                font-size: 14px;
                color: #666;
                line-height: 40px;
                margin: 10px 0;
                text-align: left;
                padding: 0 20px;
                &:first-child{
                    border-right: 1px solid #EBEEF5;
                }
            }
        }
    }

    .energy-title{
        font-size: 14px;
        color: #666;
        line-height: 24px;
    }
    .energy-num{
        font-size: 30px;
        color: #333;
        left: 48px;
        span{
            font-size: 14px;
        }
    }
</style>